export default __webpack_public_path__ + "static/media/ic_cheveron_single_right_circle.a3917dca.svg";